/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "DigitalWalletState": {
            "values": {
              "REQUESTED": 1,
              "VERIFICATION_REQUESTED": 2,
              "REJECTED": 3,
              "SUSPENDED": 4,
              "ACTIVE": 5,
              "REJECTED_INTERNALLY": 6,
              "FAILED": 7,
              "TERMINATED": 8,
              "REQUEST_DECLINED": 9
            }
          },
          "DigitalWalletIssuer": {
            "values": {
              "APPLE_PAY": 1,
              "ANDROID_PAY": 2,
              "SAMSUNG_PAY": 3,
              "MICROSOFT_PAY": 4,
              "VISA_CHECKOUT": 5,
              "FACEBOOK": 6,
              "NETFLIX": 7,
              "UNKNOWN_WALLET_ISSUER": 8,
              "FITBIT_PAY": 9,
              "GARMIN_PAY": 10,
              "SPOTIFY": 11,
              "ALIPAY": 12,
              "STRIPE": 13,
              "VIACOM_INTERNATIONAL": 14,
              "AMAZON": 15,
              "UBER": 16,
              "SCENTBIRD": 17,
              "SONY_PLAYSTATION": 18,
              "ONE_PAY": 19,
              "DOORDASH": 20,
              "SHOPIFY": 21,
              "MICROSOFT_NETWORK": 22,
              "PAYPAL": 23,
              "AUTOZONE": 24,
              "WORLDPAY": 25,
              "STARBUCKS": 26,
              "TIDAL": 27,
              "CLASSDOJO": 28,
              "ANGIES_LIST": 29,
              "ADOBE": 30,
              "EBAY": 31
            }
          },
          "DeviceType": {
            "values": {
              "MOBILE_PHONE": 1,
              "WATCH": 2,
              "TABLET": 3,
              "LAPTOP": 4,
              "PERSONAL_COMPUTER": 5,
              "WEARABLE": 6,
              "UNKNOWN_DEVICE_TYPE": 10
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.DigitalWalletState && !$root.nested?.squareup?.nested?.banklin?.nested?.DigitalWalletIssuer && !$root.nested?.squareup?.nested?.banklin?.nested?.DeviceType) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE DigitalWalletState @ squareup/banklin/digital_wallet.proto at 64:1
 */
export const DigitalWalletState = $root.lookupEnum('squareup.banklin.DigitalWalletState').values;
/**
 * SOURCE DigitalWalletIssuer @ squareup/banklin/digital_wallet.proto at 85:1
 */
export const DigitalWalletIssuer = $root.lookupEnum('squareup.banklin.DigitalWalletIssuer').values;
/**
 * SOURCE DeviceType @ squareup/banklin/digital_wallet.proto at 196:1
 */
export const DeviceType = $root.lookupEnum('squareup.banklin.DeviceType').values;
